import type { GridApi } from 'ag-grid-community'
import { type MutableRefObject, useEffect, useRef } from 'react'

/**
 * Marks the metric grid row the issue list is filtered to. The rule itself
 * lives in styles/overrides.less, next to the rest of the dashboard's grid
 * styling; `is-clickable` on the wrapper is what gives these rows a pointer.
 */
export function metricRowClass(selected: boolean): string | undefined {
  return selected ? 'metric-row-selected' : undefined
}

/**
 * Keeps that mark in step with the selection. AG Grid only recomputes
 * `getRowClass` when a row's own data changes (see RowCtrl.postProcessCss), so
 * a grid whose highlight comes from state outside it has to ask for the
 * repaint itself.
 *
 * Returns the ref to hand to GraviGrid's `externalRef`, which fills it in on
 * grid-ready -- hence the optional call.
 */
export function useMetricRowHighlight(
  selected: string | null,
): MutableRefObject<GridApi> {
  const gridApiRef = useRef() as MutableRefObject<GridApi>

  useEffect(() => {
    gridApiRef.current?.redrawRows()
  }, [selected])

  return gridApiRef
}
